import { render, staticRenderFns } from "./SimuVillageHost.vue?vue&type=template&id=4fe1ce7a&scoped=true"
import script from "./SimuVillageHost.vue?vue&type=script&lang=js"
export * from "./SimuVillageHost.vue?vue&type=script&lang=js"
import style0 from "./SimuVillageHost.vue?vue&type=style&index=0&id=4fe1ce7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe1ce7a",
  null
  
)

export default component.exports